$(function () {
    if($('.landing-edit-mode').length > 0) {
        return;
    }
    $('.b-text-block h2, .b-text-cols h2').each(function(){
        if($(this).text().length < 2) {
            $(this).remove();
        }
    })
})
